import { Input } from "@/components/ui/input";
import { DualRangeSlider } from "../ui/dual-range-slider";

export const MIN_AGE = 18;
export const MAX_AGE = 60;

export default function AgeRangeSelector({
  value,
  onChange,
}: {
  value: number[] | undefined;
  onChange: (value: (number | null)[]) => void;
}) {
  const handleAgeChange = (sliderValue: number[]) => {
    onChange(sliderValue);
  };

  const handleInputChangeMin = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(event.target.value, 10);
    if (isNaN(newValue)) {
      onChange([null, value ? value[1] : MAX_AGE]);
      return;
    }
    onChange([newValue, value ? value[1] : MAX_AGE]);
  };

  const handleInputChangeMax = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(event.target.value, 10);
    if (isNaN(newValue)) {
      onChange([value ? value[0] : MIN_AGE, null]);
      return;
    }
    onChange([value ? value[0] : MIN_AGE, newValue]);
  };

  const handleBlurMax = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(event.target.value, 10);
    if (isNaN(newValue) || newValue < MIN_AGE) {
      onChange([value ? value[0] : MIN_AGE, MIN_AGE]);
      return;
    } else if (newValue > MAX_AGE) {
      onChange([value ? value[0] : MIN_AGE, MAX_AGE]);
      return;
    }
  };

  const handleBlurMin = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(event.target.value, 10);
    if (isNaN(newValue) || newValue < MIN_AGE) {
      onChange([MIN_AGE, value ? value[1] : MAX_AGE]);
      return;
    } else if (newValue > MAX_AGE) {
      onChange([MAX_AGE, value ? value[1] : MAX_AGE]);
      return;
    }
  };

  return (
    <div className="flex flex-row items-center w-full max-w-2xl">
      <div className="flex flex-row w-full gap-2 items-center">
        <DualRangeSlider
          value={value ? [value[0], value[1]] : [MIN_AGE, MAX_AGE]}
          onValueChange={handleAgeChange}
          max={MAX_AGE}
          min={MIN_AGE}
          step={1}
          className="flex-grow hover:cursor-pointer"
        />
        <div className="flex items-center flex-shrink-0">
          <Input
            type="number"
            inputMode="numeric"
            value={value ? value[0] : ""}
            onChange={handleInputChangeMin}
            onBlur={handleBlurMin}
            className="w-10 px-0 text-center text-base [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
          />
        </div>
        <span className="text-sm text-muted-foreground">-</span>
        <div className="flex items-center flex-shrink-0">
          <Input
            type="number"
            inputMode="numeric"
            value={value ? value[1] : ""}
            onChange={handleInputChangeMax}
            onBlur={handleBlurMax}
            className="w-10 px-0 text-center text-base [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
          />
        </div>
      </div>
      <span className="text-nowrap text-gray-400 w-fit ml-1">
        {value && value[1] === MAX_AGE && "+"}
      </span>
    </div>
  );
}
